import type { ComponentType } from 'react';
import HomePage from './pages/HomePage';
import RulesPage from './pages/RulesPage';
import SweepstakesPage from './pages/SweepstakesPage';
import PrivacyPage from './pages/PrivacyPage';
import PrivacySettingsPage from './pages/PrivacySettingsPage';
import CookiePolicyPage from './pages/CookiePolicyPage';
import TermsPage from './pages/TermsPage';
import LeaderboardPage from './pages/LeaderboardPage';
import RegisterPage from './pages/RegisterPage';
import WeeklyRulesPage from './pages/WeeklyRulesPage';
import PlayPage from './pages/PlayPage';
import GamePage from './pages/GamePage';
import AccountPage from './pages/AccountPage';
import EmailPreferencesPage from './pages/EmailPreferencesPage';
import AdminPage from './pages/AdminPage';
import NotFoundPage from './pages/NotFoundPage';
import { PAGE_META, type PageMetaEntry } from './lib/routeMeta';

export type AppRoute = {
  path: string;
  Component: ComponentType;
  meta: PageMetaEntry;
};

export const routes: AppRoute[] = [
  { path: PAGE_META.home.path, Component: HomePage, meta: PAGE_META.home },
  { path: PAGE_META.rules.path, Component: RulesPage, meta: PAGE_META.rules },
  { path: PAGE_META.sweepstakes.path, Component: SweepstakesPage, meta: PAGE_META.sweepstakes },
  { path: PAGE_META.privacy.path, Component: PrivacyPage, meta: PAGE_META.privacy },
  { path: PAGE_META.privacySettings.path, Component: PrivacySettingsPage, meta: PAGE_META.privacySettings },
  { path: PAGE_META.cookies.path, Component: CookiePolicyPage, meta: PAGE_META.cookies },
  { path: PAGE_META.terms.path, Component: TermsPage, meta: PAGE_META.terms },
  { path: PAGE_META.leaderboard.path, Component: LeaderboardPage, meta: PAGE_META.leaderboard },
  { path: PAGE_META.register.path, Component: RegisterPage, meta: PAGE_META.register },
  { path: PAGE_META.weeklyRules.path, Component: WeeklyRulesPage, meta: PAGE_META.weeklyRules },
  { path: PAGE_META.play.path, Component: PlayPage, meta: PAGE_META.play },
  { path: PAGE_META.playGame.path, Component: GamePage, meta: PAGE_META.playGame },
  { path: PAGE_META.account.path, Component: AccountPage, meta: PAGE_META.account },
  { path: PAGE_META.emailPreferences.path, Component: EmailPreferencesPage, meta: PAGE_META.emailPreferences },
  { path: PAGE_META.admin.path, Component: AdminPage, meta: PAGE_META.admin },
];

export const notFoundRoute: AppRoute = {
  path: '*',
  Component: NotFoundPage,
  meta: PAGE_META.notFound,
};
